/** @jsxImportSource @emotion/react */
import { Pages } from 'modules/navigation/domain/enums/pages';
import React, { useEffect } from 'react';
import type { DivProps } from 'typings';
import UDHeaderTitle from 'ud-ui/components/header-title';
import UDLink from 'ud-ui/components/link';
import { useMainLayout } from 'modules/app-shell/ui/layout/context';
import * as S from './styles';

interface IProps extends DivProps {}

function ComponentsPage(props: IProps) {
  const { ...rest } = props;
  const { setHeaderContent } = useMainLayout();

  useEffect(() => {
    setHeaderContent(<UDHeaderTitle>Компоненты</UDHeaderTitle>);
    return () => setHeaderContent(null);
  }, [setHeaderContent]);

  return (
    <S.MainBlock {...rest}>
      <ul>
        <li>
          <UDLink to={Pages.TESTS.builders.component('table')} type="title-1">
            Таблица
          </UDLink>
        </li>
        <li>
          <UDLink to={Pages.TESTS.FABRIC_EDITOR_DEMO} type="title-1">
            Fabric Editor
          </UDLink>
        </li>
        <li>
          <UDLink to={Pages.TESTS.TYPOGRAPHY} type="title-1">
            Типографика
          </UDLink>
        </li>
        <li>
          <UDLink to={Pages.TESTS.MODALS} type="title-1">
            Модальные окна
          </UDLink>
        </li>
      </ul>
    </S.MainBlock>
  );
}

export default ComponentsPage;
